/** ----------------------------------------
    IBAN
---------------------------------------- */

import { Validator } from 'vee-validate';

Validator.extend('password', {
    validate (value) {
        var regex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
        return regex.test(value);
    },
    getMessage (field) {
        return `The ${field} field must be at least 8 character long and contain a uppercase letter, lowercase letter and number`;
    }
});